import React from "react";
import { ExplainerSection, NAVY, CYAN, LIME, INK, LIGHT } from "./ExplainerSection";

const KvmIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="KVM-Virtualisierung: ein Server, viele virtuelle Maschinen">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Physical server */}
    <rect x="60" y="40" width="280" height="150" rx="6" fill="#fff" stroke={NAVY} strokeWidth="3" />
    <text x="200" y="62" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={NAVY} letterSpacing="2">PHYSISCHER SERVER · KVM</text>
    {/* VMs appearing */}
    {[0, 1, 2, 3].map((i) => (
      <g key={i} opacity="0">
        <animate attributeName="opacity" values="0;1;1;1;0" dur="6s" begin={`${i * 0.8}s`} repeatCount="indefinite" />
        <rect x={80 + i * 62} y="80" width="52" height="70" rx="4" fill={i % 2 === 0 ? NAVY : CYAN} />
        <text x={106 + i * 62} y="112" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="11" fontWeight="bold" fill="#fff">VM{i + 1}</text>
        <circle cx={106 + i * 62} cy="132" r="4" fill={LIME} />
      </g>
    ))}
    {/* Hypervisor layer */}
    <rect x="80" y="160" width="240" height="16" rx="2" fill={LIME} opacity="0.9" />
    <text x="200" y="172" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fontWeight="bold" fill={INK}>HYPERVISOR</text>
    <text x="200" y="215" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>1 HARDWARE · VIELE UNABHÄNGIGE SERVER</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      KVM-VIRTUALISIERUNG
    </text>
  </svg>
);

const ScaleIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Serverkapazität wächst mit dem Unternehmen">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Growing bars */}
    {[{ x: 70, h: 60, d: "0s", c: NAVY }, { x: 150, h: 100, d: "0.4s", c: CYAN }, { x: 230, h: 140, d: "0.8s", c: NAVY }, { x: 310, h: 175, d: "1.2s", c: LIME }].map((b, i) => (
      <g key={i}>
        <rect x={b.x} y={210 - b.h} width="50" height={b.h} fill={b.c}>
          <animate attributeName="height" values={`0;${b.h}`} dur="1.2s" begin={b.d} fill="freeze" />
          <animate attributeName="y" values={`210;${210 - b.h}`} dur="1.2s" begin={b.d} fill="freeze" />
        </rect>
        {[...Array(Math.floor(b.h / 24))].map((_, r) => (
          <line key={r} x1={b.x + 6} y1={200 - r * 24} x2={b.x + 44} y2={200 - r * 24} stroke="#fff" strokeWidth="2" opacity="0.5" />
        ))}
      </g>
    ))}
    {/* Arrow up */}
    <path d="M 60 180 Q 200 60 345 35" fill="none" stroke={LIME} strokeWidth="3" strokeDasharray="8 6">
      <animate attributeName="stroke-dashoffset" values="100;0" dur="3s" repeatCount="indefinite" />
    </path>
    <polygon points="345,35 330,32 338,48" fill={LIME} />
    <text x="80" y="235" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>START</text>
    <text x="290" y="235" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>WACHSTUM</text>
    <text x="200" y="252" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      KAPAZITÄT WÄCHST MIT · OHNE NEUKAUF
    </text>
  </svg>
);

const GermanyIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Hosting in deutschen Rechenzentren">
    <rect width="400" height="260" fill={INK} />
    {/* Racks */}
    {[0, 1, 2].map((i) => (
      <g key={i}>
        <rect x={60 + i * 70} y="60" width="55" height="130" rx="3" fill={NAVY} stroke={CYAN} strokeWidth="1" />
        {[0, 1, 2, 3].map((r) => (
          <g key={r}>
            <rect x={68 + i * 70} y={70 + r * 30} width="39" height="20" rx="2" fill={INK} stroke={CYAN} strokeWidth="0.8" />
            <circle cx={100 + i * 70} cy={80 + r * 30} r="2.5" fill={LIME}>
              <animate attributeName="opacity" values="1;0.2;1" dur="1.4s" begin={`${(i + r) * 0.25}s`} repeatCount="indefinite" />
            </circle>
          </g>
        ))}
      </g>
    ))}
    {/* DE badge with flag */}
    <g>
      <circle cx="325" cy="105" r="38" fill={INK} stroke={LIME} strokeWidth="2.5" />
      <rect x="303" y="88" width="44" height="10" fill="#111" stroke="#333" strokeWidth="0.5" />
      <rect x="303" y="98" width="44" height="10" fill="#DD0000" />
      <rect x="303" y="108" width="44" height="10" fill="#FFCE00" />
      <text x="325" y="138" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="11" fontWeight="900" fill={LIME}>DE</text>
    </g>
    <text x="325" y="175" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill="#fff" opacity="0.8">TÜV-ZERTIFIZIERT</text>
    <text x="325" y="188" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill="#fff" opacity="0.8">DSGVO-KONFORM</text>
    <text x="200" y="230" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      IHRE DATEN VERLASSEN DEUTSCHLAND NICHT
    </text>
  </svg>
);

const UptimeIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="99,98 Prozent Verfügbarkeit mit 24/7 Support">
    <rect width="400" height="260" fill={LIGHT} />
    <rect x="40" y="30" width="320" height="180" rx="8" fill="#fff" stroke={NAVY} strokeWidth="2" />
    <rect x="40" y="30" width="320" height="24" rx="8" fill={NAVY} />
    <circle cx="55" cy="42" r="3" fill={LIME} />
    <text x="70" y="46" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="1">SERVER-STATUS · LIVE</text>
    {/* Heartbeat line */}
    <polyline points="60,150 110,150 125,110 140,180 155,150 220,150 235,115 250,178 265,150 340,150" fill="none" stroke={LIME} strokeWidth="3" strokeLinejoin="round" strokeDasharray="600" strokeDashoffset="600">
      <animate attributeName="stroke-dashoffset" values="600;0" dur="3s" repeatCount="indefinite" />
    </polyline>
    <text x="60" y="90" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK} letterSpacing="1">UPTIME</text>
    <text x="60" y="112" fontFamily="ui-monospace, monospace" fontSize="20" fontWeight="900" fill={NAVY}>99,98 %</text>
    <text x="250" y="90" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK} letterSpacing="1">SUPPORT</text>
    <text x="250" y="112" fontFamily="ui-monospace, monospace" fontSize="20" fontWeight="900" fill={CYAN}>24/7</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      ÜBERWACHT · GEWARTET · ERREICHBAR
    </text>
  </svg>
);

const ITEMS = [
  { step: "01", illu: KvmIllu, title: "Ein Server, viele Maschinen", desc: "KVM-Virtualisierung teilt starke Hardware in unabhängige virtuelle Server. Sie bekommen volle Admin-Rechte auf Ihrer eigenen Maschine – ohne eigene Hardware kaufen zu müssen.", testId: "kvm" },
  { step: "02", illu: ScaleIllu, title: "Kapazität wächst einfach mit", desc: "Mehr Mitarbeiter, mehr Daten, mehr Last? Wir skalieren CPU, RAM und Speicher in Minuten nach oben – ohne Umzug, ohne Ausfallzeit, ohne Neukauf.", testId: "scale" },
  { step: "03", illu: GermanyIllu, title: "Ihre Daten bleiben in Deutschland", desc: "Alle Server stehen in TÜV-zertifizierten deutschen Rechenzentren. Das bedeutet: DSGVO-Konformität ab Werk, kein US-Cloud-Act, kurze Wege und deutsches Recht.", testId: "germany" },
  { step: "04", illu: UptimeIllu, title: "Wir wachen, damit alles läuft", desc: "99,98 % Verfügbarkeit sind kein Zufall: Monitoring rund um die Uhr, automatische Updates, redundante Systeme – und ein Experten-Team, das Sie 24/7 erreichen.", testId: "uptime" },
];

export const ServerExplainers = () => (
  <ExplainerSection
    eyebrow="So funktioniert Managed Server Hosting"
    titleA="Vier Bausteine."
    titleB="Einfach erklärt."
    intro="Server-Hosting muss kein Blackbox-Thema sein. Hier sehen Sie visuell, was hinter unserem Managed Hosting steckt – und warum Ihre Anwendungen bei uns gut aufgehoben sind."
    items={ITEMS}
    testId="server-explainers"
  />
);
